import React, { useState, useRef } from "react";
import { SketchPicker } from "react-color";
import { PeekBox, PeekPopper, PeekClickAwayListener, PeekPaper, PeekTypography } from "@piiqtechnologies/ui-components";
export const ColorPicker = ({ value = "#000000", onChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const buttonRef = useRef(null);
    const open = Boolean(anchorEl);
    const normalizedColor = value && value !== "none" ? value : "#000000";
    const colorHex = normalizedColor.startsWith("#") ? normalizedColor : `#${normalizedColor}`;
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl((prev) => (prev ? null : buttonRef.current || event.currentTarget));
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleChangeComplete = (color) => {
        onChange(color.hex);
    };
    return (React.createElement(PeekBox, { sx: { position: "relative", display: "inline-block" } },
        React.createElement(PeekBox, { ref: buttonRef, onClick: handleClick, onMouseDown: (e) => {
                e.preventDefault();
            }, sx: {
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                padding: "4px 8px",
                userSelect: "none",
                minHeight: "28px",
                "&:hover": {
                    opacity: 0.8,
                },
            }, title: "Fill Color", role: "button", tabIndex: 0, onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick(e);
                }
            } },
            React.createElement(PeekTypography, { variant: "body2", sx: { fontSize: "0.875rem", color: "text.primary", whiteSpace: "nowrap" } }, "Color"),
            React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", style: {
                    pointerEvents: "none",
                    border: "1px solid rgba(0, 0, 0, 0.23)",
                    borderRadius: "2px",
                    display: "block",
                    flexShrink: 0,
                } },
                React.createElement("rect", { fill: colorHex, opacity: "1", width: "16", height: "16" }))),
        React.createElement(PeekPopper, { open: open && !!anchorEl, anchorEl: anchorEl, placement: "bottom-start", sx: { zIndex: 9999 }, disablePortal: false },
            React.createElement(PeekClickAwayListener, { onClickAway: handleClose },
                React.createElement(PeekPaper, { elevation: 3, sx: { mt: 1, p: 0 } },
                    React.createElement(SketchPicker, { color: colorHex, onChangeComplete: handleChangeComplete }))))));
};
export default ColorPicker;
